export const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
    <path
      fill="currentColor"
      d="M13.129 7.13c.616.387.616 1.352 0 1.738l-7.97 4.996c-.616.386-1.387-.097-1.387-.87v-9.99c0-.772.77-1.255 1.387-.869l7.97 4.996Z"
    />
  </svg>
);
